
<div class="card card-{{_type}} {{_additionalClasses}}" *ngIf="!_close_card"
    [class.card-collapsed]="_isCollapsed"
    [class.card-maximized]="_isMaximixed"
    #hostContent>
    <div class="card-header {{_extraHeaderClass}}">
        <div class="card-title">
            <ng-template [ngTemplateOutlet]="CardTitle"></ng-template>
        </div>
        <div class="card-controls" *ngIf="_showTools">
            <ul *ngIf="!_minimalHeader; else minimalBlock" class="position-relative">
                <ng-template [ngTemplateOutlet]="CardExtraControls"></ng-template>
                <li *ngIf="_refresh"><a href="javascript:void(0);" data-toggle class="card-refresh" (click)='refresh()' title="Refresh"><i class="card-icon card-icon-refresh"></i></a>
                </li>
                <li *ngIf="_toggle"><a href="javascript:void(0);" data-toggle class="card-collapse" (click)='toggle()' title="Toggle"><i class="card-icon card-icon-collapse" [class.pg-arrow_minimize]="_isCollapsed"></i></a>
                </li>
                <li *ngIf="_maximize"><a  href="javascript:void(0);" data-toggle class="card-maximize" (click)='maximize()' title="Maximize"><i class="card-icon card-icon-maximize"></i></a>
                </li>
                <li *ngIf="_close"><a href="javascript:void(0);" data-toggle class="card-close" (click)='close()' title="Close"><i class="card-icon card-icon-close"></i></a>
                </li>
                <li class="card-icon-refresh-lg-{{_refreshColor === 'light' ? 'white' : 'master'}}-animated" style="position: absolute;top:-8px;right:-16px" [class.active]="_isLoading" [class.hide]="!_isLoading"></li>
            </ul>
        <ng-template #minimalBlock>
            <ul>
                <li>
                    <a href="javascript:void(0);" (click)='refresh()' class="card-refresh minimal" [class.refreshing]="_isLoading">
                        <i #minimalCircleLoadingTrigger class="card-icon card-icon-refresh-lg-{{_refreshColor === 'light' ? 'white' : 'master'}}" [class.fade]="_isLoading"></i>
                        <i #minimalCircleLoading
                        class="card-icon-refresh-lg-{{_refreshColor === 'light' ? 'white' : 'master'}}-animated" style="position: absolute;top:0;left:0" [class.active]="_isLoading"  [class.hide]="_isLoading != true"></i>
                    </a>
                </li>
            </ul>
        </ng-template>
        </div>
    </div>
    <div class="card-body {{_extraBodyClass}}" [@collapseState]="_isCollapsed ?'inactive' : 'active'">
        <ng-content></ng-content>
    </div>
    <div *ngIf="_messageVisible" class="pgn-wrapper" data-position="top">
        <div class="pgn pgn-bar push-on-sidebar-open">
            <div class="alert alert-danger">
                <span>{{_message}}</span><button class="close" (click)='alertDismiss()' type="button"><span aria-hidden="true">×</span><span class="sr-only">Close</span></button>
            </div>
        </div>
    </div>
    <div *ngIf="_messageVisible" class="card-progress" [style.backgroundColor] = "_minimalHeader && _refreshColor === 'white' ? 'rgba(0,0,0, 0.6)' : 'rgba(255, 255, 255, 0.8)'" style=" display: block;">

    </div>
    <div [@fadeAnimation]="_isLoading" class="card-progress"  [style.backgroundColor] = "_minimalHeader && _refreshColor === 'white' ? 'rgba(0,0,0, 0.6)' : 'rgba(255, 255, 255, 0.8)'" style="display: block;pointer-events: none">
        <pg-progress *ngIf="_minimalHeader" type="{{_progressType}}" color="{{_progressColor}}" [indeterminate]="true" class=""></pg-progress>
    </div>
</div>
